<template>
<div class="profile">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-12">
			<div class="card">
				<div class="card-header bg-white border-0">
					<div class="row align-items-center">
						<div class="col-8">
							<h3 class="mb-0 text-left">{{$t("forms.profile.profile")}}</h3>
						</div>
						<div class="col-4 text-right">
							<router-link class="btn btn-sm btn-primary" :to="{ name: 'editProfile'}">{{$t('actions.edit')}}</router-link>
							<button class="btn btn-sm btn-danger ml-3" @click="logout">{{$t('actions.logOut')}}</button>
						</div>
					</div>
					<hr>
				</div>
				<div class="card-body">
					<div v-show="isLoading">
						<div class="spinner-border text-warning" role="status"><span class="sr-only">Loading...</span></div>
					</div>
					<form v-show="!isLoading">
						<!-- <h6 class="heading-small text-muted mb-4">User information</h6> -->
						<div class="pl-lg-4">
							<div class="row">
								<div class="col-lg-6">
									<div class="form-group mb-3">
										<router-link class="btn btn-primary mr-3"  :to="{ name: 'book-servie' }">
											<h5 class="text-center mb-0" for="input-email">{{$t("forms.profile.bookNowButton")}}</h5>
										</router-link>

										<router-link class="btn btn-primary ml-3" replace :to="{ name: 'reservations' }">
											<h5 class="text-center mb-0" for="input-email">{{$t("forms.profile.myReservations")}}</h5>
										</router-link>
									</div>
									<div class="form-group">
										<h3 class="text-left" for="input-email">{{$t("forms.profile.subscription")}}: 
											<span style="text-transform: capitalize">{{subscription}}</span>
										</h3>										
									</div>
									<div class="form-group text-left">
										<h3 class="text-left d-inline-block" for="input-email">{{$t("forms.profile.credit")}}: {{remainingCredit | round(2, true)}} {{currency}}</h3>
										<router-link class="btn btn-sm btn-link ml-1 align-middle" style="margin-bottom: 8px;"
											replace :to="{ name: 'transactions' }">
											{{$t("forms.profile.creditLogLabel")}}
										</router-link>									
									</div>
								</div>
								<div class="col-lg-6">
									<div class="form-group text-left">
										<b>{{$t("forms.general.email")}}: </b> {{email}}
									</div>
									<div class="form-group text-left">
										<b>{{$t("forms.general.name")}}: </b> {{salutation}} {{firstName}} {{lastName}}
									</div>
									<div class="form-group text-left">
										<b>{{$t("forms.general.phone")}}: </b> {{phone}}
									</div>
									<div class="form-group text-left">
										<b>{{$t("forms.general.address")}}: </b> {{address}}
									</div>
									<div>
										<router-link class="btn btn-sm btn-primary" replace :to="{ name: 'changePassword'}">
											{{$t('actions.changePassword')}}
										</router-link>
									</div>
								</div>
							</div>
						</div>
						<hr class="my-4">
						<!-- Description -->
						<!-- <h6 class="heading-small text-muted mb-2">Other Info</h6> -->
						<div class="row">
							<div class="col-lg-6">
								<div class="form-group text-left">
									<b>{{$t("forms.profile.defaultCar")}}: </b> {{defaultCar}}
								</div>
							</div>
							<div class="col-lg-6">
								<div class="form-group text-left">
									<b>{{$t("forms.profile.otherCars")}}: </b> {{otherCars}}
								</div>
							</div>
							<div class="col-lg-6">
								<div class="form-group text-left">
									<b>{{$t("forms.profile.instructionsForPlanner")}}: </b> {{instructionsForPlanner}}
								</div>
							</div>
							<div class="col-lg-6">
								<div class="form-group text-left">
									<b>{{$t("forms.profile.instructionsForDriver")}}: </b> {{instructionsForDriver}}
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapActions } from "vuex";
import { round } from "./../utils/filters.js";

export default {
	data() {
		return {
			isLoading: true,
			email: null,
			salutation: null,
			firstName: null,
			lastName: null,
			phone: null,
			address: null,
			defaultCar: null,
			otherCars: null,
			instructionsForPlanner: " - ",
			instructionsForDriver: " - ",
			subscription: ' None ',
			remainingCredit: 0,
			currency: 'CHF'
		};
	},
	filters: {
		round: round
	},
	computed: {
		//...mapState('account', ['status'])
	},
	created() {
		this.getUserProfile().then(result=>{
			//console.log(result);
			this.email = result.email;
			this.salutation = result.salutation;
			this.firstName = result.firstName;
			this.lastName = result.lastName;
			this.phone = result.phoneNumber;
			this.defaultCar = result.defaultCar;
			this.currency = result.currency;
			this.instructionsForPlanner = result.instructionsForDispatcher;
			this.instructionsForDriver = result.instructionsForDriver;
			if(result.otherCars)
				this.otherCars = result.otherCars.join(", ");

			if(result.subscription)
				this.subscription = result.subscription;

			if(result.remainingCredit)
				this.remainingCredit = result.remainingCredit;

			if(result.pickupAddress)
				this.address = result.pickupAddress.formatterAddress;

			this.isLoading = false;
		});
  },
  methods: {
    ...mapActions("account", ["getUserProfile", "logout"]),
  }
};
</script>